import { useUIOnlyFeatureFlag } from "~/hooks/useUIOnlyFeatureFlag";
export function useIsRoutingVNextEnabled(): boolean {
    const [isRoutingVNextEnabled] = useIsRoutingVNextFeature();
    return isRoutingVNextEnabled;
}
export function useIsRoutingVNextFeature() {
    return useUIOnlyFeatureFlag("Routing vNext", false);
}
